import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Container fluid className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light px-4 text-center">

      <h1 className="fw-black text-#5A3099 mb-0" style={{ fontSize: 'calc(5rem + 5vw)', lineHeight: '1' }}>
        404
      </h1>
      <p className="text-uppercase fw-bold tracking-wider text-info mb-2" style={{ letterSpacing: '0.2rem' }}>
        Page Not Found
      </p>

      <h2 className="display-4 fw-bold text-dark mb-3">
        Lost in space?
      </h2>

      <p className="text-secondary mx-auto mb-5" style={{ maxWidth: '450px' }}>
        The page you are looking for doesn't exist or has been moved. 
        Don't worry, even the best explorers get lost sometimes.
      </p>

      <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
        <button
          onClick={() => navigate(-1)}
          className="primary-btn mt-0 pl-4 pr-4"
          style={{ width: '160px' }}
        >
          Go Back
        </button>
      </div>
    </Container>
  );
};

export default PageNotFound;